import Layout from '@/views/layout/Layout'
const designerRouter = {
    path: '/designer',
    name: 'designer',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 设计师路由
        {
            path: '/designerIndex',
            name: 'designerIndex',
            meta: { name: '设计师列表'},
            component: () => import('@/views/designer/index'),
        },
        // 设计师详情页路由
        {
            path: '/designerDetail',
            name: 'designerDetail',
            meta: { name: '设计师详情'},
            component: () => import('@/views/designer/detail'),
        },
        // 设计师作品页路由
        {
            path: '/designerWorks',
            name: 'designerWorks',
            meta: { name: '作品详情'},
            component: () => import('@/views/designer/works'),
        },
    ]
}
export default designerRouter


// WEBPACK FOOTER //
// ./src/router/modules/designer.js